import PageProtected from "../../../../components/Page/PageProtected";
import SectionDashboard from "../../../../components/Section/SectionDashboard";
import SectionPathoRisk from "./Sections/SectionPathoRisk";
import SectionPathoRiskNoStars from "./Sections/SectionPathoRiskNoStars";
import SectionDisclaimer from "../../../../components/Disclaimer/SectionDisclaimer"
import DisclaimerCard from "./DisclaimerCard";
import { useTheme } from "@mui/material";

export default function WatchlistWelcome() {

    const theme = useTheme();

return (
<>
    


    <PageProtected
    
    headline="GENETICS - " 
    specify ="PERSONAL WATCHLIST"

    main={<> 

    {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C300"
            Section_1={<SectionPathoRisk />}

            colorSection_2="grey.C400"
            Section_2={  <SectionPathoRiskNoStars /> }
            
            colorSection_3="grey.C100"
            Section_3= {<> <SectionDisclaimer disclaimer={<DisclaimerCard />} /> </>} 

            colorSection_4="grey.C200"
            Section_4={ "" }

        />

):(

    <SectionDashboard

            colorContainer="transparent"

            colorSection_1="greydark.C900"
            Section_1={<SectionPathoRisk />}

            colorSection_2="greydark.C700"
            Section_2={ <SectionPathoRiskNoStars /> }
            
            colorSection_3="greydark.C800"
            Section_3= { <SectionDisclaimer disclaimer={<DisclaimerCard />} /> }  

            colorSection_4="greydark.C500"
            Section_4={ "" }

        />
        )}
    </>
    }
/>

</>
)
}